import Image from 'next/image';
import styles from '@components/DevToolbar/DevToolbarTab/DevToolbarTabHeader/DevToolbarTabHeader.styles';
import commonStyles from '@components/DevToolbar/DevToolbarTab/common.styles';
import Heading from '@components/Heading/Heading';
import { BASE_PATH } from '@config/index';
import getImageQuality from '@utils/getImageQuality';
import Button from '@components/Button/Button';
import Icon from '@components/icons/Icon';
import getPublicEnv from '@utils/getPublicEnv';
import { useCartStore } from '@features/cart/mobx/context/CartStoreProvider';
type PropsType = {
  name: string;
};
const DevToolbarTabHeader = ({
  name
}: PropsType) => {
  const {
    cartId
  } = useCartStore();
  const copyUrl = () => {
    void navigator.clipboard.writeText(window.location.href);
  };
  const copyCartId = () => {
    if (cartId) {
      void navigator.clipboard.writeText(cartId);
    }
  };
  return <>
      <div sx={styles.headerWrapper}>
        <Image height={29} width={39} src={`${BASE_PATH}/img/logo.svg`} quality={getImageQuality()} alt="logo" priority />
        <div sx={commonStyles.badges}>
          <div sx={commonStyles.badge(false)}>
            <div sx={commonStyles.badgeIcon}>
              <Icon icon="Download" size="16px" color="white" />
            </div>
            <b>{getPublicEnv('NEXT_PUBLIC_SERVICE_VERSION')}</b>
          </div>
          <div sx={commonStyles.badge(false)}>
            <div sx={commonStyles.badgeIcon}>
              <Icon icon="Visibility" size="16px" color="white" />
            </div>
            <b>{getPublicEnv('NEXT_PUBLIC_SERVICE_INSTANCE')}</b>
          </div>
          <div sx={commonStyles.badge(false)}>
            <div sx={commonStyles.badgeIcon}>
              <Icon icon="ShoppingCart" size="16px" color="white" />
            </div>
            <b>{cartId || 'No cart generated'}</b>

            {cartId && <Button addSx={styles.copyButton} variant="iconOnly" variantColor="white" size="small" onClick={copyCartId}>
                <Icon icon="Copy" size="16px" />
              </Button>}
          </div>
        </div>
        <Button addSx={styles.copyButton} variant="outlined" variantColor="white" size="small" onClick={copyUrl}>
          Copy URL <Icon icon="Copy" size="16px" />
        </Button>
      </div>
      <Heading h={4} headingType={4} pb={24} bold align="center" color="white">
        {name}
      </Heading>
    </>;
};
export default DevToolbarTabHeader;